module.exports = __webpack_public_path__ + "static/img/led_ab-1.5a83c32.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/led_ab-1.svg
// module id = bDld
// module chunks = 0